module.exports = __webpack_public_path__ + "img/icon_map_3_on_110.81d5837d.png";